import Vue from 'vue';
import COLORS from '@design/colors.js';
import styled from 'vue-styled-components';

import { RingLoader } from 'vue-spinners-css';

const StyledRing = styled(Vue.component('ring-loader', RingLoader))`
    & > div {
        animation-duration: 0.6s !important;
    }

    & div:nth-child(1) {
        animation-delay: -0.225s !important;
    }
    & div:nth-child(2) {
        animation-delay: -0.15s !important;
    }
    & div:nth-child(3) {
        animation-delay: -0.075s !important;
    }
`;

export default {
    name: 'RingLoader',
    functional: true,
    props: {
        color: {
            type: String,
            default: COLORS['blue-35'],
        },
        size: {
            type: Number | String,
            default: 36,
        },
    },
    render(h, { props }) {
        const { color, size } = props;
        return <StyledRing color={color} size={Number(size)} />;
    },
};
